import { Controller } from '@hotwired/stimulus'

import { dispatcher } from './pub_controller'

export class DispatcherController extends Controller {
  static values = {
    pubChannel: String,
    pubAs: String,
    pubDetail: String,
  }

  declare readonly pubChannelValue: string
  declare readonly pubAsValue: string
  declare readonly pubDetailValue: string

  dispatcher() {
    dispatcher(this, this.pubAsValue, this.pubChannelValue, this.pubDetailValue)
  }
}
